import React from "react"
import {Link} from 'react-router-dom'

import sessionManager from '../../lib/session'

const ActiveSeasonCheck = (props) => {
  const sessionData = sessionManager.getSession()
      const isAdmin = sessionData.pool && sessionData.pool.userIsAdmin === true

  return (
    <>
    {
      !sessionData.thisWeek.weekNum && (!props.bypass || props.bypass === false) &&
      <div class="no-active-week">
        <p>There is not currently an active season.</p>

        {
        isAdmin === true &&
        <Link className="nav-link" to="/season/manage">Create a new season</Link>
        }

       {
        isAdmin === false &&

        <p>Please check back later.</p>
      }
      </div>
    }
    {
     ( sessionData.thisWeek.weekNum || props.bypass === true) && 
      <>{ props.children }</>
    }
    </>
  )
}

export default ActiveSeasonCheck